import { render, staticRenderFns } from "./capt_xu_vsl_account.vue?vue&type=template&id=b32c8e62"
import script from "./capt_xu_vsl_account.vue?vue&type=script&lang=js"
export * from "./capt_xu_vsl_account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports